import {
  Client,
  createClient,
  dedupExchange,
  fetchExchange,
  subscriptionExchange
} from 'urql'
import { SubscriptionClient } from 'subscriptions-transport-ws'
import { devtoolsExchange } from '@urql/devtools'
import { IntrospectionData } from '@urql/exchange-graphcache/dist/types/ast'
import schema from '../graphql/graphql.schema.json'
import { getCacheExchange } from './urql-cache-exchange'

export const createUrqlClient = (authToken: string | null): Client => {
  const subscriptionClient = new SubscriptionClient(
    process.env.REACT_APP_GQL_WEBSOCKET as string,
    {
      reconnect: true,
      connectionParams: {
        headers: {
          Authorization: `Bearer ${authToken ?? ''}`
        }
      }
    }
  )

  return createClient({
    url: process.env.REACT_APP_GQL_ENDPOINT as string,
    suspense: true,
    fetchOptions: {
      headers: {
        Authorization: `Bearer ${authToken ?? ''}`
      }
    },
    exchanges: [
      ...(process.env.NODE_ENV === 'development' ? [devtoolsExchange] : []),
      dedupExchange,
      getCacheExchange(schema as IntrospectionData),
      ...(authToken === null
        ? []
        : [
            subscriptionExchange({
              forwardSubscription(operation) {
                return subscriptionClient.request(operation)
              }
            })
          ]),
      fetchExchange
    ]
  })
}
